(function () {
    'use strict';

    var module = angular.module('app');

    module.factory('httpErrorLogger', ['$q', function ($q) {
        return {
            'responseError': function (response) {
                if (response.status !== 401)
                    toastr.error(response.statusText, 'Error');

                return $q.reject(response);
            }
        };
    }]);

    module.config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('httpErrorLogger');
    }]);
}());